import {
  calendar_default
} from "./chunk-NUZKG5LS.js";

// src/layouts/calendar/index.ts
var calendar_default2 = calendar_default;

export {
  calendar_default2 as calendar_default
};
